module.exports = __webpack_public_path__ + "img/br.469c04be.png";